module.exports = __webpack_public_path__ + "bdf40b168ce31c67c74a48a33c4d44e4.pdf";